const decodeHtmlEntities = (value) =>
  value
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");

const stripHtmlTags = (value) =>
  decodeHtmlEntities(
    value
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
      .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
  );

/**
 * Converts HTML to plain text without assigning to innerHTML/outerHTML.
 */
export const htmlToPlainText = (html) => {
  if (html === null || html === undefined) {
    return '';
  }

  if (typeof html !== 'string') {
    return String(html);
  }

  const trimmedHtml = html.trim();
  if (!trimmedHtml) {
    return '';
  }

  if (typeof DOMParser !== 'undefined') {
    const parsedDocument = new DOMParser().parseFromString(
      trimmedHtml,
      'text/html'
    );
    return parsedDocument.body.textContent || '';
  }

  return stripHtmlTags(trimmedHtml);
};
